import React from "react";
import { getAssetUrl } from "../../../helper/BaseUrl";
export default function BlogDetailContent({ data }) {
  if (!data?.title) return null;
  const authorImageUrl = getAssetUrl(data?.author_image);
  return (
    <>
      <section className="blogcontent-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="blogcontent-mainbox">
                <div dangerouslySetInnerHTML={{ __html: data?.description1 }} />
                {data?.quotes &&
                  <div className="detail-editpara">
                    <span>  {data?.quotes} </span>
                  </div>
                }
                <div dangerouslySetInnerHTML={{ __html: data?.description2 }} />
                <div className="blog-detail-userbox">
                  {authorImageUrl && <img src={authorImageUrl} alt={data?.author_name || "Author"} />}
                  <div>
                    <small>{data?.author_name}</small>
                    <p>{data?.author_designation}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
